<!-- <div class="container-fluid mt-4">
  <div class="row">
    <div class="col-lg-4">
      <div class="card mb-4">
        <div class="card-body text-center">
          <img [src]="imgurl === '' ? 'assets/images/user.png' : imgurl" alt="Profile Image"
            class="rounded-circle img-fluid" style="width: 150px;" id="profile-img">



          <input type="file" id="img-upload" accept="image/*" class="d-none">
          <h5 class="my-3" [innerHTML]="userForm.get('sFirstName')?.value"></h5>
          <p class="text-muted mb-1"></p>
<p>{{ userForm.get('sAddress')?.value }}</p>


        </div>
      </div>

    </div>
    <div class="col-lg-8">
      <form [formGroup]="userForm">

        <input type="hidden" formControlName="sImageSrc" id="sImageSrc" accept="image/*" class="d-none">
        <div class="card mb-4">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-3">
                <p class="mb-0">First Name</p>
              </div>
              <div class="col-sm-9">
                <input type="text" formControlName="sFirstName" class="form-control" placeholder="Enter First Name">

              </div>
            </div>
            <hr>
            <div class="row">
              <div class="col-sm-3">
                <p class="mb-0">Last Name</p>
              </div>
              <div class="col-sm-9">
                <input type="text" formControlName="sLastName" class="form-control" placeholder="Enter Last Name">
              </div>
            </div>
            <hr>
            <div class="row">
              <div class="col-sm-3">
                <p class="mb-0">Email</p>
              </div>
              <div class="col-sm-9 row">
                <div class="col-sm-9">
                  <input type="email" formControlName="sEmail" class="form-control" placeholder="Enter Email"
                    [readonly]="emailVerified">

                </div>
                <div class="col-sm-3">
                  <button type="button" *ngIf="!emailVerified" [disabled]="userForm.get('sEmailId')?.invalid"
                    class="btn btn-sm btn-primary" (click)="checkDuplicateEmailOrMobile(1)">
                    Verify
                  </button>
                  <span id="verifiedMark" *ngIf="emailVerified">✅ </span>

                </div>
              </div>
            </div>
            <hr>

            <div class="row">
              <div class="col-sm-3">
                <p class="mb-0">Mobile</p>
              </div>
              <div class="col-sm-9 row">
                <div class="col-sm-9">
                  <input type="text" formControlName="sMobile" class="form-control col-sm-9"
                    placeholder="Enter Mobile Number" [readonly]="phoneVerfied">

                </div>
                <div class="col-sm-3">
                  <button type="button" (click)="checkDuplicateEmailOrMobile(2)" *ngIf="!phoneVerfied"
                    [disabled]=" userForm.get('sMobile')?.invalid" class="btn btn-sm btn-primary">
                    Verify
                  </button>
                  <span id="verifiedMark" *ngIf="phoneVerfied">✅</span>

                </div>



              </div>
            </div>
            <hr>
            <div class="row">
              <div class="col-sm-3">
                <p class="mb-0">Address</p>
              </div>
              <div class="col-sm-9">
                <input type="text" formControlName="sAddress" class="form-control" placeholder="Enter Address">
              </div>
            </div>
            <hr>
            <button type="submit" class="btn btn-primary mt-4" (click)="Submitdata()">
              Submit
            </button>
          </div>
        </div>
      </form>
      <div class="modal fade" id="otpEmailModal" tabindex="-1" aria-labelledby="otpEmailModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-md modal-dialog-scrollable">

          <div class="modal-content">

            <div class="modal-header">
              <h5 class="modal-title" id="otpEmailModalLabel">OTP Verification</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                (click)="closeOtPModel()"></button>
            </div>
            <div class="modal-body">
              <h6>Enter the OTP sent to your {{maskString}}</h6>
              <div class="row">
                <div class="col-md-12">
                  <label class="mb-1 text-dark">OTP Number<span class="text-danger">*</span></label>
                  <input type="text" class="form-control" [(ngModel)]="txtOTPNumberEmail" minlength="6" maxlength="6"
                    [pattern]="'^[0-9]*$'" (keypress)="[allowOnlyNumbers($event),phoneVerfied = false]" />
                  <span class="text-danger">{{countdownEmail}}</span>
                </div>
              </div>

            </div>
            <div class="modal-header">
              <div class="row">
                <div class="col-md-12">
                  <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>&nbsp;
                  <button type="button" class="btn btn-primary" (click)="verifyOTP(1)">Verify OTP</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal fade" id="otpPhoneModal" tabindex="-1" aria-labelledby="otpPhoneModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-sm modal-dialog-scrollable">

          <div class="modal-content">

            <div class="modal-header">
              <h5 class="modal-title" id="otpPhoneModalLabel">OTP Verification</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                (click)="closeOtPModel()"></button>
            </div>
            <div class="modal-body">
              <h6>Enter the OTP sent to your {{maskString}}</h6>
              <div class="row">
                <div class="col-md-12">
                  <label class="mb-1 text-dark">OTP Number<span class="text-danger">*</span></label>
                  <input type="text" class="form-control" [(ngModel)]="txtOTPNumber" minlength="6" maxlength="6"
                    [pattern]="'^[0-9]*$'" (keypress)="[allowOnlyNumbers($event),phoneVerfied = false]" />
                  <span class="text-danger">{{countdownMobile}}</span>
                </div>
              </div>

            </div>
            <div class="modal-header">
              <div class="row">
                <div class="col-md-12">
                  <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>&nbsp;
                  <button type="button" class="btn btn-primary" (click)="verifyOTP(2)">Verify OTP</button>
                </div>
              </div>
            </div>
        
          </div>
        </div>
      </div>
    </div>
    </div>
    </div> -->

<div class="container-fluid mt-4">

  <div class="row justify-content-center">

    <div class="col-lg-10">

      <!-- PROFILE CARD -->
      <div class="card shadow-sm border-0 profile-card">

        <div class="card-body p-4">

          <div class="row align-items-center">

            <!-- LEFT -->
            <div class="col-lg-4 text-center border-end">

              <!-- PROFILE IMAGE -->
              <div class="profile-image-wrapper mx-auto mb-3">

                <img
                  [src]="previewImage || imgurl || 'assets/images/user.png'"
                  class="profile-img"
                  alt="Profile">

              </div>

              <h4 class="fw-bold mb-1">
                {{ userForm.get('sFirstName')?.value }}
                {{ userForm.get('sLastName')?.value }}
              </h4>

              <p class="text-muted mb-3">
                {{ userForm.get('sAddress')?.value }}
              </p>

              <!-- EDIT BUTTON -->
              <button
                class="btn btn-primary px-4"
                data-bs-toggle="modal"
                data-bs-target="#editProfileModal">

                <i class="bi bi-pencil-square me-2"></i>
                Edit Profile

              </button>

            </div>

            <!-- RIGHT -->
            <div class="col-lg-8">

              <div class="row g-4">

                <!-- EMAIL -->
                <div class="col-md-6">

                  <div class="detail-card">

                    <span class="detail-label">
                      Email Address
                    </span>

                    <h6 class="detail-value">

                      {{ userForm.get('sEmail')?.value }}

                      <span
                        class="text-success ms-2"
                        *ngIf="emailVerified">

                        <i class="bi bi-patch-check-fill"></i>

                      </span>

                    </h6>

                  </div>

                </div>

                <!-- MOBILE -->
                <div class="col-md-6">

                  <div class="detail-card">

                    <span class="detail-label">
                      Mobile Number
                    </span>

                    <h6 class="detail-value">

                      {{ userForm.get('sMobile')?.value }}

                      <span
                        class="text-success ms-2"
                        *ngIf="phoneVerfied">

                        <i class="bi bi-patch-check-fill"></i>

                      </span>

                    </h6>

                  </div>

                </div>

                <!-- ADDRESS -->
                <div class="col-12">

                  <div class="detail-card">

                    <span class="detail-label">
                      Address
                    </span>

                    <h6 class="detail-value">
                      {{ userForm.get('sAddress')?.value }}
                    </h6>

                  </div>

                </div>

              </div>

            </div>

          </div>

        </div>

      </div>

    </div>

  </div>

</div>

<!-- ========================================= -->
<!-- EDIT PROFILE MODAL -->
<!-- ========================================= -->

<div
  class="modal fade"
  id="editProfileModal"
  tabindex="-1"
  aria-hidden="true">

  <div class="modal-dialog modal-lg modal-dialog-centered">

    <div class="modal-content border-0">

      <!-- HEADER -->
      <div class="modal-header border-0 pb-0">

        <h4 class="modal-title fw-bold">
          Edit Profile
        </h4>

        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal">
        </button>

      </div>

      <!-- BODY -->
      <div class="modal-body p-4">

        <form [formGroup]="userForm">

          <!-- PROFILE IMAGE -->
          <div class="text-center mb-4">

            <div class="profile-image-wrapper mx-auto">

              <img
                [src]="previewImage || imgurl || 'assets/images/user.png'"
                class="profile-img"
                alt="Profile">

              <!-- UPLOAD -->
              <label
                for="img-upload"
                class="upload-btn">

                <i class="bi bi-camera-fill"></i>

              </label>

              <input
                type="file"
                id="img-upload"
                hidden
                accept="image/*"
                (change)="onImageSelected($event)">

            </div>

          </div>

          <div class="row g-3">

            <!-- FIRST NAME -->
            <div class="col-md-6">

              <label class="form-label">
                First Name
              </label>

              <input
                type="text"
                formControlName="sFirstName"
                class="form-control">

            </div>

            <!-- LAST NAME -->
            <div class="col-md-6">

              <label class="form-label">
                Last Name
              </label>

              <input
                type="text"
                formControlName="sLastName"
                class="form-control">

            </div>

            <!-- EMAIL -->
            <div class="col-md-6">

              <label class="form-label">
                Email Address
              </label>

              <div class="input-group">

                <input
                  type="email"
                  formControlName="sEmail"
                  class="form-control"
                  [readonly]="emailVerified">

                <!-- VERIFY -->
                <button
                  type="button"
                  class="btn btn-outline-primary"
                  *ngIf="!emailVerified"
                  [disabled]="userForm.get('sEmail')?.invalid"
                  (click)="checkDuplicateEmailOrMobile(1)">

                  Verify

                </button>

                <!-- VERIFIED -->
                <span
                  class="input-group-text text-success"
                  *ngIf="emailVerified">

                  <i class="bi bi-patch-check-fill"></i>

                </span>

              </div>

            </div>

            <!-- MOBILE -->
            <div class="col-md-6">

              <label class="form-label">
                Mobile Number
              </label>

              <div class="input-group">

                <input
                  type="text"
                  formControlName="sMobile"
                  class="form-control"
                  [readonly]="phoneVerfied">

                <!-- VERIFY -->
                <button
                  type="button"
                  class="btn btn-outline-primary"
                  *ngIf="!phoneVerfied"
                  [disabled]="userForm.get('sMobile')?.invalid"
                  (click)="checkDuplicateEmailOrMobile(2)">

                  Verify

                </button>

                <!-- VERIFIED -->
                <span
                  class="input-group-text text-success"
                  *ngIf="phoneVerfied">

                  <i class="bi bi-patch-check-fill"></i>

                </span>

              </div>

            </div>

            <!-- ADDRESS -->
            <div class="col-12">

              <label class="form-label">
                Address
              </label>

              <textarea
                rows="3"
                formControlName="sAddress"
                class="form-control"></textarea>

            </div>

          </div>

        </form>

      </div>
<div
  class="modal fade"
  id="otpEmailModal"
  tabindex="-1"
  aria-labelledby="otpEmailModalLabel"
  aria-hidden="true"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  data-bs-focus="false">

  <div class="modal-dialog modal-dialog-centered modal-sm">

    <div class="modal-content border-0 shadow">

      <!-- HEADER -->
      <div class="modal-header">

        <h5 class="modal-title">
          OTP Verification
        </h5>

        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal">
        </button>

      </div>

      <!-- BODY -->
      <div class="modal-body">

        <p class="text-muted small">
          Enter OTP sent to {{ maskString }}
        </p>

        <input
          type="text"
          class="form-control"
          name="txtOTPNumberEmail"
          [(ngModel)]="txtOTPNumberEmail"
          minlength="6"
          maxlength="6"
          pattern="[0-9]*"
          placeholder="Enter OTP"
          (keypress)="allowOnlyNumbers($event)">

        <small class="text-danger">
          {{ countdownEmail }}
        </small>

      </div>

      <!-- FOOTER -->
      <div class="modal-footer">

        <button
          type="button"
          class="btn btn-light"
          data-bs-dismiss="modal">

          Close

        </button>

        <button
          type="button"
          class="btn btn-primary"
          (click)="verifyOTP(1)">

          Verify OTP

        </button>

      </div>

    </div>

  </div>

</div>
 <div class="modal fade" id="otpPhoneModal" tabindex="-1" aria-labelledby="otpPhoneModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-sm modal-dialog-scrollable">

          <div class="modal-content">

            <div class="modal-header">
              <h5 class="modal-title" id="otpPhoneModalLabel">OTP Verification</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                (click)="closeOtPModel()"></button>
            </div>
            <div class="modal-body">
              <h6>Enter the OTP sent to your {{maskString}}</h6>
              <div class="row">
                <div class="col-md-12">
                  <label class="mb-1 text-dark">OTP Number<span class="text-danger">*</span></label>
                  <input type="text" class="form-control" [(ngModel)]="txtOTPNumber" minlength="6" maxlength="6"
                    [pattern]="'^[0-9]*$'" (keypress)="[allowOnlyNumbers($event),phoneVerfied = false]" />
                  <span class="text-danger">{{countdownMobile}}</span>
                </div>
              </div>

            </div>
            <div class="modal-header">
              <div class="row">
                <div class="col-md-12">
                  <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>&nbsp;
                  <button type="button" class="btn btn-primary" (click)="verifyOTP(2)">Verify OTP</button>
                </div>
              </div>
            </div>
        
          </div>
        </div>
      </div>
      <!-- FOOTER -->
      <div class="modal-footer border-0">

        <button
          type="button"
          class="btn btn-light"
          data-bs-dismiss="modal">

          Cancel

        </button>

        <button
          type="button"
          class="btn btn-success px-4"
          (click)="Submitdata()">

          <i class="bi bi-check-circle me-2"></i>
          Update Profile

        </button>

      </div>

    </div>

  </div>

</div>


     
    